export const firebaseConfig = {
    apiKey: "AIzaSyA7QgHIxT-Wrkgj50kBl0TsEtJLH3DnMlQ",
    authDomain: "sports-algos.firebaseapp.com",
    projectId: "sports-algos",
    storageBucket: "sports-algos.appspot.com",
    messagingSenderId: "571917601507",
    appId: "1:571917601507:web:ead82536696960b25893d6",
    measurementId: "G-XL5YKFPEDK"
};